export default {
  getProjects({ commit }) {
    commit('LOADING_PROJECTS', true)
    return new Promise(((resolve, reject) => {
      this._vm.$http.get(`/projects`)
        .then(({ data }) => {
          commit('ADD_PROJECTS', data);
          resolve();
        })
        .catch(() => {
          commit('LOADING_PROJECTS', false)
          reject();
        });
    }));
  },
  getProjectsPaginated({ commit }, { page, itemsPerPage }) {
    commit('LOADING_PROJECTS', true)
    return new Promise(((resolve, reject) => {
      this._vm.$http.get(`/projects/paginated?page=${page}&itemsPerPage=${itemsPerPage}`)
        .then(({ data }) => {
          commit('ADD_PROJECTS', data);
          resolve();
        })
        .catch(() => {
          commit('LOADING_PROJECTS', false)
          reject();
        });
    }));
  },
};
